export const GET_TYPE_SETTING = 'GET_TYPE_SETTING'
export const GET_TYPE_SETTING_EXITO = 'GET_TYPE_SETTING_EXITO'
export const GET_TYPE_SETTING_ERROR = 'GET_TYPE_SETTING_ERROR'
